<template>
	<div class="datepicker-wrap">
		<el-date-picker
					v-model="current_date"
					type="date"
					@change="change"
					:placeholder="placeholder">
			</el-date-picker>
			<label v-if="show_floating_label" :class="current_date==''?'':'risen'">{{ placeholder }}</label>
	</div>
</template>
<script>
	export default {
		name: "NewDatepickerWrapper",
		props: {
    value: {

    },
    type: {
      type: String,
      default: "normal",
    },
    placeholder: {
      type: String,
    },
    notFound: {
      type: String,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show_floating_label: {
      type: Boolean,
      default: true
    }
  },
		data(){
			return {
				current_date:'',
			}
		},
		mounted() {
    this.current_date = this.value
  },
		methods:{
			change() {
    this.$emit('change', this.current_date)
   }
		},	
  watch: {
    value(){
      this.current_date = this.value
    }
  },
	}
</script>

<style lang="less">
.datepicker-wrap {
  display: 	block;
  position: relative;
}

.datepicker-wrap input.el-input__inner:placeholder-shown{
  padding-top: 0;
  font-size: 14px;
}
</style>

<style scoped>
label{
	opacity: 0;
	font-size: 14px;
	margin-top: -2.5rem;
	margin-left: 1.125em;
	transition: all 0.5s;
	opacity: 0;
  position: absolute;
}
  label.risen{
	font-size: 10px;
	margin-top: -.5em;
	position: absolute;
	margin-top: -3.25rem;
	position: absolute;
	margin-left: 1.5em;
	opacity: .4;
  left: 0;
  top: 4px;
  margin-top: 0;
	transition: all 0.5s;
}


</style>